import {
  ExportWarehouseExistQuantity,
  ExportWarehouseName,
  ExportWarehouseNote,
  ExportWarehouseRequestQuantity,
  ExportWarehouseTimeUse,
  ExportWarehouseUnit,
} from "./_fields";
import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";

type ExportWarehouseTemplate = {
  ExportWarehouseExistQuantity: string;
  ExportWarehouseName: string;
  ExportWarehouseNote: string;
  ExportWarehouseRequestQuantity: string;
  ExportWarehouseTimeUse: string;
  ExportWarehouseUnit: string;
};

export const exportWarehouseTemplate: TemplatesValue<ExportWarehouseTemplate> = {
  fileName: "DanhSachDeNghiXuatKho",
  sheet: DEFAULT_SHEET_NAME,
  structures: [
    ExportWarehouseName,
    ExportWarehouseUnit,
    ExportWarehouseRequestQuantity,
    ExportWarehouseExistQuantity,
    ExportWarehouseTimeUse,
    ExportWarehouseNote,
  ],
  fields: [
    "ExportWarehouseName",
    "ExportWarehouseUnit",
    "ExportWarehouseRequestQuantity",
    "ExportWarehouseExistQuantity",
    "ExportWarehouseTimeUse",
    "ExportWarehouseNote",
  ],
};
